import {
  type FabricWebviewCrossWebviewCallApi,
  sendCrossWebviewCall,
} from './cross-webview-call.js';
import {
  type FabricWebviewGetCurrentPagesApi,
  getCurrentPages,
} from './get-current-pages.js';
import type { FabricWebviewHideNavbarApi } from './hide-navbar.js';
import { hideNavbar } from './hide-navbar.js';
import { type FabricWebviewLocationToApi, locationTo } from './location-to.js';
import {
  type FabricWebviewNavgateBackApi,
  navigateBack,
} from './navigate-back.js';
import { type FabricWebviewNavigateToApi, navigateTo } from './navigate-to.js';
import { type FabricWebviewRedirectToApi, redirectTo } from './redirect-to.js';
import { type FabricWebviewRelaunchApi, reLaunch } from './relaunch.js';
import {
  type FabricWebviewSubscriptionApi,
  subscription,
} from './subscription.js';
import { type FabricWebviewSwitchTabApi, switchTab } from './switch-tab.js';

export type FabricWebviewApi = {
  /**
   * 跨 `webview` 异步调用任何webview的数据内容, 并获取返回的回调结果
   */
  sendCrossWebviewCall: FabricWebviewCrossWebviewCallApi;
  /**
   * 获取当前webview页面栈。数组中第一个元素为首页，最后一个元素为当前页面
   */
  getCurrentPages: FabricWebviewGetCurrentPagesApi;
  /**
   * 关闭当前页面，返回上一页面或多级页面。可通过获取当前的页面栈, 决定需要返回几层
   */
  navigateBack: FabricWebviewNavgateBackApi;
  /**
   * 保留当前页面，打开新的webview页面, 但是不能跳到 tabbar 页面。
   * 使用 navigateBack 可以返回到原页面。
   */
  navigateTo: FabricWebviewNavigateToApi;
  /**
   * 关闭当前页面，打开新的webview页面。但是不允许跳转到 tabbar 页面
   */
  redirectTo: FabricWebviewRedirectToApi;
  /**
   * 保留当前webview窗口，刷新打开下一个指定的网页, 并且自动强制重置navbar的所有配置(自动重新获取新的URL地址的document.title)
   * 并且让默认的back按钮支持栈会退, 再到webview退出, 如果新页面自定义配置了navbar, 新Navbar行为能力与 `setNavbar`配置能力为准.
   */
  locationTo: FabricWebviewLocationToApi;
  /**
   * 关闭所有页面，打开到应用内的某个页面, 保留当前tabbar, 停留的页面如果有.
   */
  reLaunch: FabricWebviewRelaunchApi;
  /**
   * 跳转到 tabBar 页面，并关闭其他所有非 tabBar webview页面
   */
  switchTab: FabricWebviewSwitchTabApi;

  /**
   * 订阅webview状态, 目前支持onShow, onHide, onLoad, onBackground, onIosBackGesture.
   */
  subscription: FabricWebviewSubscriptionApi;
  /**
   * 隐藏navbar
   */
  hideNavbar: FabricWebviewHideNavbarApi;
};

export const fabricWebview: FabricWebviewApi = {
  sendCrossWebviewCall,
  getCurrentPages,
  navigateBack,
  navigateTo,
  redirectTo,
  locationTo,
  reLaunch,
  switchTab,
  subscription,
  hideNavbar,
};
